/**
 * Converts a string to title case by capitalizing the first letter of each word,
 * while preserving the existing case of the rest of each word.
 * Words are separated by spaces or hyphens.
 *
 * Examples:
 * - "hello WORLD" -> "Hello WORLD"
 * - "HELLO world" -> "HELLO World"
 * - "the QUICK-brown FOX" -> "The QUICK-Brown FOX"
 * - "camelCase" -> "CamelCase"
 *
 * @param str - The string to format
 * @returns The string with the first letter of each word capitalized, rest unchanged
 */
const formatTitleCasePreserveCase = (str: string): string => {
  if (str.length === 0) return str;

  // Split on spaces and hyphens, but keep the separators
  const parts = str.split(/(\s+|-+)/);

  return parts
    .map((part) => {
      // Only process actual words (not separators)
      if (part.trim() === "" || /^[-]+$/.test(part)) {
        return part; // Return separators as-is
      }
      // Capitalize first letter, preserve the rest
      return part.charAt(0).toUpperCase() + part.slice(1);
    })
    .join("");
};

export default formatTitleCasePreserveCase;
